'use client';

import type { AiSuggestionsProps } from '../types';
import { SparkleIcon } from '../icons';

export default function AiSuggestions({ suggestions, onSuggestionClick }: AiSuggestionsProps) {
  if (suggestions.length === 0) return null;

  return (
    <div className="flex flex-col items-start gap-3 self-stretch py-4 px-9 bg-brand/10">
      {/* Title row */}
      <div className="flex items-start gap-3 self-stretch animate-fadeIn">
        <SparkleIcon className="w-[29px] h-6 flex-shrink-0" />
        <h3 className="text-[22px] font-gotham font-bold text-text-primary leading-[28px]">
          ΑΙ Προτάσεις
        </h3>
      </div>

      {/* Chips — flex-wrap creates rows naturally */}
      <div className="flex items-center gap-3 flex-wrap animate-fadeIn">
        {suggestions.map((suggestion, idx) => (
          <button
            key={idx}
            onClick={() => onSuggestionClick(suggestion)}
            className="flex items-center py-2 px-4 gap-2 rounded-lg bg-white text-[14px] font-gotham font-medium text-black leading-[20px] hover:bg-brand hover:text-brand-text transition-colors cursor-pointer"
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
}
